/**
 * ToastContainer - Display toast notifications
 */
import React from 'react';
import { useToast } from '../../contexts/ToastContext';
import '../../styles/toast.css';

const ToastContainer = () => {
  const { toasts, removeToast } = useToast();

  const getIcon = (variant) => {
    switch (variant) {
      case 'success':
        return 'bi-check-circle-fill';
      case 'danger':
        return 'bi-x-circle-fill';
      case 'warning':
        return 'bi-exclamation-triangle-fill';
      case 'info':
      default:
        return 'bi-info-circle-fill';
    }
  };

  if (toasts.length === 0) return null;

  return (
    <div className="toast-container position-fixed top-0 end-0 p-3" style={{ zIndex: 9999 }}>
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`toast show align-items-center text-bg-${toast.variant} border-0 mb-2`}
          role="alert"
          aria-live="assertive"
          aria-atomic="true"
        >
          <div className="d-flex">
            <div className="toast-body d-flex align-items-center gap-2">
              <i className={`bi ${getIcon(toast.variant)}`}></i>
              {toast.message}
            </div>
            <button
              type="button"
              className="btn-close btn-close-white me-2 m-auto"
              onClick={() => removeToast(toast.id)}
              aria-label="Close"
            ></button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
